import { render, staticRenderFns } from "./BookCoverDetails.vue?vue&type=template&id=7e42aa64&scoped=true"
import script from "./BookCoverDetails.vue?vue&type=script&lang=js"
export * from "./BookCoverDetails.vue?vue&type=script&lang=js"
import style0 from "./BookCoverDetails.vue?vue&type=style&index=0&id=7e42aa64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e42aa64",
  null
  
)

export default component.exports